import { render, staticRenderFns } from "./TabelaDetalhesProdutos.vue?vue&type=template&id=68ec3dbc&scoped=true"
import script from "./TabelaDetalhesProdutos.vue?vue&type=script&lang=js"
export * from "./TabelaDetalhesProdutos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ec3dbc",
  null
  
)

export default component.exports